import useCurrentLanguage from 'canvas_states/language/useCurrentLanguage';
import type { ThemeProviderProps } from '../ThemeProvider/ThemeProvider';
import { ThemeProviderMarkup } from '../ThemeProvider/ThemeProvider';
import { useBuildTheme } from '../ThemeProvider/useCurrentTheme';
import isRightToLeft from '../../utils/languages/isRightToLeft';

/**
 * used when app is loaded outside the usual Router framework
 * (example: the `manageMyBooking` widget)
 */
export interface ThemeProviderStandaloneProps extends ThemeProviderProps {
  scopeCssBaseline?: boolean;
}

export const ThemeProviderStandalone = ({ children, scopeCssBaseline, ...props }: ThemeProviderStandaloneProps) => {
  const theme = useBuildTheme(props);
  const currentLanguage = useCurrentLanguage().states.currentLanguage;

  return theme ? (
    <ThemeProviderMarkup
      theme={{ ...theme, direction: isRightToLeft(currentLanguage) ? 'rtl' : 'ltr' }}
      scopeCssBaseline={scopeCssBaseline}
    >
      {children}
    </ThemeProviderMarkup>
  ) : null;
};

ThemeProviderStandalone.displayName = 'ThemeProvider';

export default ThemeProviderStandalone;
